module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Book-9dc55b3097c8741bc69023430e6aa835.svg";